export default "__VITE_ASSET__BqPIfa4R__"